import { render } from "./approve.html?vue&type=template&id=6751205d&scoped=true&external"
import script from "./approve.vue?vue&type=script&lang=js"
export * from "./approve.vue?vue&type=script&lang=js"

import "./approve.vue?vue&type=style&index=0&id=6751205d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6751205d"]])

export default __exports__